import React, { useEffect, useState } from "react";
import { useParams, withRouter } from "react-router-dom";
import {
  BackButton,
  Breadcrumbs,
  LinkButton,
  SendToast,
  Text,
  Wrapper,
} from "@networkraildigitalfactory/components";

import ObjectivesContent from "../ObjectivesContent/ObjectivesContent";
import OneToOnesContent from "../OneToOnesContent/OneToOnesContent";
import PerformanceContent from "../MyPerformanceContent/MyPerformanceContent";
import { useUsers } from "../../hooks/useAPI";
import TabTable from "../TabTable/TabTable";
import { RemoveEmployeeModal, AccessDeniedModal } from "../Modals";
import PageTitle from "../PageTitle/PageTitle";
import useUser from "../../hooks/useUser";

import styles from "./MyTeamIndividual.module.css";

const MyTeamIndividual = (props) => {
  const {
    user,
    setEmployeeBeingViewed,
    setOneToOnesFilters,
    oneToOnesFilters,
    setObjectivesFilters,
    objectivesFilters,
    setPerformanceFilters,
    performancesFilters,
    setIsLineManager,
    history,
  } = props;
  const params = useParams();
  const [isRemoveEmployeeModalOpen, setIsRemoveEmployeeModalOpen] = useState(false);
  const [isAccessDeniedModalOpen, setIsAccessDeniedModalOpen] = useState(false);
  const [listOfTabs, setListOfTabs] = useState([]);
  const [{ data }] = useUsers(props.match.params.email);
  setEmployeeBeingViewed(data);
  const navTo = (dest) => history.push(dest);
  const toggleRemoveEmployeeModal = () => {
    setIsRemoveEmployeeModalOpen(!isRemoveEmployeeModalOpen);
  };

  const openAccessDeniedModal = () => {
    setIsAccessDeniedModalOpen(true);
  };

  const onCloseAccessDeniedModal = () => {
    setIsAccessDeniedModalOpen(false);
    navTo("/my-team/");
  };

  const displayAccessDeniedModal = (postError) => {
    if (postError && postError.error && postError.error.response) {
      const { error } = postError;
      const { response } = error;

      if (response.status === 403) {
        openAccessDeniedModal();
      }
    }
  };

  const { isGBR } = useUser(props.match.params.email);

  useEffect(() => {
    if (history.location.pathname.includes(user.email)) {
      SendToast("Forbidden", "error");
      history.push("/my-team");
    }
  });

  const tabsList = [
    {
      name: `1-2-1s`,
      data: (
        <div id="1-2-1sPanel">
          <OneToOnesContent
            displayAccessDeniedModal={displayAccessDeniedModal}
            employeeEmail={props.match.params.email}
            isLineManagerView
            setOneToOnesFilters={setOneToOnesFilters}
            oneToOnesFilters={oneToOnesFilters}
          />
        </div>
      ),
    },
    {
      name: `Objectives`,
      data: (
        <div id="objectivesPanel">
          <ObjectivesContent
            displayAccessDeniedModal={displayAccessDeniedModal}
            employeeEmail={props.match.params.email}
            isLineManagerView
            setObjectivesFilters={setObjectivesFilters}
            objectivesFilters={objectivesFilters}
          />
        </div>
      ),
    },
    {
      name: `PDP`,
      data: (
        <div id="pdpPanel">
          <ObjectivesContent
            displayAccessDeniedModal={displayAccessDeniedModal}
            employeeEmail={props.match.params.email}
            isLineManagerView
            setObjectivesFilters={setObjectivesFilters}
            objectivesFilters={objectivesFilters}
            type="PDP"
          />
        </div>
      ),
    },
    {
      name: `Performance`,
      data: (
        <div id="performancePanel">
          <PerformanceContent
            displayAccessDeniedModal={displayAccessDeniedModal}
            employeeEmail={props.match.params.email}
            isLineManagerView
            setPerformanceFilters={setPerformanceFilters}
            performancesFilters={performancesFilters}
            type="Performance"
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    setListOfTabs(tabsList);
  }, []);

  let defaultActive;
  switch (params.defaultTab) {
    case "oneToOnes":
      defaultActive = "1-2-1s";
      break;
    case "PDP":
      defaultActive = "pdp";
      break;
    case "Performance":
      defaultActive = "performance";
      break;
    default:
      defaultActive = "objectives";
      break;
  }

  return (
    <>
      <div className={styles.breadcrumbs_wrapper}>
        <Breadcrumbs
          items={[
            {
              text: "My Team",
              onClick: () => {
                navTo("/my-team");
              },
            },
            { text: data && data.fullName },
          ]}
        />
      </div>
      <Wrapper maxWidth={1350} align="center">
        <BackButton
          text="back to my team"
          onClick={() => {
            navTo(`/my-team`);
          }}
          style={{ lineHeight: "140%", letterSpacing: "0.0015em", padding: 0, width: "150px" }}
        />
        <PageTitle isCustom>
          {isGBR ? (
            <div className={`${styles.org_tag} ${styles.gbr_tag}`}>GBRTT</div>
          ) : (
            <div className={`${styles.org_tag} ${styles.nr_tag}`}>Network Rail </div>
          )}
          <Text wrapper="h2" type="subtitle" className={styles.title_header}>
            {data && data.fullName}
            <Text wrapper="span" type="body" style={{ color: "#37519d", marginLeft: "15px" }}>
              {data && data.empNo}
            </Text>
          </Text>
          <Text
            wrapper="span"
            type="body"
            style={{
              marginBottom: "0.5rem",
              lineHeight: "140%",
              letterSpacing: "0.0015em",
              color: "#353535",
              fontWeight: "bold",
            }}
          >
            {data && data.jobTitle}
          </Text>
          <div className={styles.link_wrapper}>
            <Text wrapper="span" type="body" style={{ fontSize: "16px", color: "#353535" }}>
              If you no longer manage this employee, please click
            </Text>
            <LinkButton
              id="removeEmployee"
              onClick={toggleRemoveEmployeeModal}
              style={{ color: "#353535", marginLeft: "3px" }}
            >
              here
            </LinkButton>
          </div>
        </PageTitle>
        <div className={styles.tab_container}>
          <TabTable
            style={{ fontSize: "18px", lineHeight: "140%", letterSpacing: "0.0015em" }}
            tabs={listOfTabs}
            defaultActive={defaultActive}
          />
        </div>
      </Wrapper>
      <RemoveEmployeeModal
        show={isRemoveEmployeeModalOpen}
        close={toggleRemoveEmployeeModal}
        employeeData={data && data}
        user={user}
        setIsLineManager={setIsLineManager}
      />
      <AccessDeniedModal show={isAccessDeniedModalOpen} close={onCloseAccessDeniedModal} />
    </>
  );
};

export default withRouter(MyTeamIndividual);
